import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, remove, push, connectDatabaseEmulator } from "firebase/database";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getMessaging, getToken } from "firebase/messaging";


export const firebaseConfig = {
  apiKey: "AIzaSyCXd53HHNAoLURl5LnteJA5Iex_12047lA",
  authDomain: "kontaktuj-ma.firebaseapp.com",
  databaseURL: "https://kontaktuj-ma-default-rtdb.firebaseio.com",
  projectId: "kontaktuj-ma",
  storageBucket: "kontaktuj-ma.appspot.com",
  messagingSenderId: "428624448537",
  appId: "1:428624448537:web:0ab689e1a24d6177baee88",
  measurementId: "G-XNGKWK0501"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
if (process.env.REACT_APP_USE_EMULATORS === "true") {
  console.log("CONNECTING TO EMULATORS...")
  connectDatabaseEmulator(db, "localhost", 9000);
  connectAuthEmulator(auth, "http://localhost:9099");
}

export const messaging = getMessaging(app);

export const saveOrder = async (userId, order) => {
  const ordersRef = ref(db, "users/" + userId + "/orders");
  const newOrderRef = push(ordersRef);
  await set(newOrderRef, order); // čakáš na uloženie
  return newOrderRef.key; // vrátiš ID vygenerovaného orderu
};

export const registerNotifications = (userId, onSuccess) => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        // request notification access
        return Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            return getToken(messaging, {
              vapidKey: 'BEVhxjvR3Z3LINBgSV-p2ZkJ7EiFBY9x5eqmc7tn5wTVyocn9GiweYdUi6QHmc_GZu3w6DInPITCu51-UZyTCs8',
              serviceWorkerRegistration: registration
            });
          } else {
            throw new Error('No notification permission');
          }
        });
      })
      .then((currentToken) => {
        console.log('FCM token:', currentToken);
        // odošli token na tvoj server
        // uloženie do Realtime DB
        // Referencia na FCM tokens pre daného používateľa
        set(ref(db, "users/" + userId + "/fcmTokens/" + currentToken), {
          updatedAt: Date.now()
        });

        // save token into localStorage
        localStorage.setItem("fcmToken", currentToken);

        onSuccess();
      })
      .catch(err => console.error('FCM error:', err));
  }
}

export const unregisterNotifications = async (userId, onSuccess) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      await subscription.unsubscribe();
      console.log("Push subscription unsubscribed");
    }

    const currentToken = localStorage.getItem("fcmToken");
    if (currentToken) {
      await remove(ref(db, `users/${userId}/fcmTokens/${currentToken}`));
      localStorage.removeItem("fcmToken");
      console.log("Token zmazaný z DB aj lokálne");
    }

    if (onSuccess) onSuccess();
  } catch (err) {
    console.error("Chyba pri deaktivácii notifikácií:", err);
  }
};

//TMP: migration script

    /*   console.log("TOTO JE ONO")
      console.log(snapshot.val())

      const result = {}
      const chatLinksResult = {};

      const msgs = snapshot.val();
      Object.keys(msgs)
        .forEach(channel => Object.keys(msgs[channel])
          .forEach(sender => Object.keys(msgs[channel][sender])
            .forEach(msgTimestamp => {

              const message = {
                aliasA: channel,
                aliasB: sender,
                content: msgs[channel][sender][msgTimestamp].content,
                time: msgTimestamp
              }

              const chatIdArray = [message.aliasA, message.aliasB]
              chatIdArray.sort();
              const chatId = chatIdArray[0] + "_" + chatIdArray[1];

              if (!result[chatId]) {
                result[chatId] = {}
              }
              result[chatId][msgTimestamp] = message;

              //update chatLinks
              if (!chatLinksResult[message.aliasA]) {
                chatLinksResult[message.aliasA] = {}
              }
              chatLinksResult[message.aliasA][message.aliasB] = true;


              if (!chatLinksResult[message.aliasB]) {
                chatLinksResult[message.aliasB] = {}
              }
              chatLinksResult[message.aliasB][message.aliasA] = true;
            }
            )))
      console.log(result);

      window.result = result;
      window.chatLinksResult = chatLinksResult;

      window.buildNewDB = (data) => {

      }

      window.setChats = (data) => {
        const message = data;
        set(ref(db, 'chats'), message).then(res => { });
      }

      window.setChatLinks = (data) => {
        const message = data;
        set(ref(db, 'chatLinks'), message).then(res => { });
      }
      // if (snapshot.val()) {
      //   setAllMsgs(snapshot.val());
      //   setSenders(Object.keys(snapshot.val()))
      // }
     */